import { Box, Container } from '@mui/material'
import { motion, Variants } from 'framer-motion'

import React from 'react'
import { Helmet } from 'react-helmet'

import Data from "../Data/.json";
import { useTranslation } from 'react-i18next';

interface Titre {
    titre: string,
    lien?: string,
    image?: any,
    pageDescription: string,
    keyWords: string,
    hiddeTitle?: true

}
function TitrePage(props: Titre) {
    const { t, i18n } = useTranslation();


    const scroll: Variants = {
        offscreen: {
            y: 15,
            opacity: .5
        },
        onscreen: {
            y: 10,
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };

    const scroll2: Variants = {
        offscreen: {
            opacity: .5
        },
        onscreen: {
            opacity: 1,
            transition: {
                bounce: 0.6,
                duration: 1
            }
        }
    };

    return (
        <>
            {/* https://www.ibgalphatech.com/static/media/IBG%20Logo%20without%20background.3bf9cbb04490c8b56cacb2513b95de16.svg */}
            <Helmet>
                <title>{t(props.titre) + " - " + Data.site_name}</title>
                <meta name="description" content={t(props.pageDescription)} />
                <meta name="keywords" content={t(props.keyWords)} />
                <meta name="author" content={Data.site_name} />

                {/* Open Graph */}
                <meta property="og:title" content={t(props.titre) + " - " + Data.site_name} />
                <meta property="og:description" content={t(props.pageDescription)} />
                <meta property="og:image" content={"https://www.ibgalphatech.com/static/media/IBG%20Logo%20without%20background.3bf9cbb04490c8b56cacb2513b95de16.svg"} />
                <meta property="og:url" content={Data.site_link} />
                <meta property="og:type" content="website" />

                {/* Twitter Cards */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={t(props.titre) + " - " + Data.site_name} />
                <meta name="twitter:description" content={t(props.pageDescription)} />
                <meta name="twitter:image" content={"https://www.ibgalphatech.com/static/media/IBG%20Logo%20without%20background.3bf9cbb04490c8b56cacb2513b95de16.svg"} />
                <meta name="twitter:creator" content={Data.site_name} />

                {/* Open Graph locale (si multilingue) */}
                <meta property="og:locale" content={i18n.language + "_" + (i18n.language == "fr" ? "FR" : "US")} />
                <meta property="og:site_name" content={Data.site_name} />
            </Helmet>
            {!props.hiddeTitle ?
                <div>
                    <motion.div
                        initial="offscreen"
                        whileInView="onscreen"
                        viewport={{ once: false, amount: 0.8 }}
                        variants={scroll2}
                    >
                        <img className='imgFontTitle' src={props.image} alt="" />
                    </motion.div>
                    <div className={"titrePage"}>
                        <motion.div
                            initial="offscreen"
                            whileInView="onscreen"
                            viewport={{ once: false, amount: 0.8 }}
                            variants={scroll}
                        >
                            <Box sx={{ display: { xs: 'flex', md: 'block' } }} >
                                <b>{t(props.titre).toUpperCase()}</b>
                                <hr />
                                <center style={{ fontSize: '100%', color: "rgba(255, 255, 255, .8)" }}>{t("Label.Accueil") + " / " + t(props.lien + "")}</center>
                            </Box>
                        </motion.div>
                    </div>
                </div>

                :
                <></>
            }
        </>

    )
}

export default TitrePage
